import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { Tooltip } from "antd";
import { getIconMutedColor } from "../../utils/helpers";

import "./insightsLabelIndicator.scss";

const InsightsLabelIndicator = ({ insights, onClick, allInsights }) => {
  const [activeLabels, setActiveLabels] = useState([]);

  const themeDark = useSelector(
    (state) => state.userPreferencesReducer.themeDark
  );

  const labels = [
    {
      name: "Reliability",
      icon: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <g clipPath="url(#clip0_4880_6112)">
            <path
              d="M11.0368 6.59489C10.7783 9.25168 9.24559 11.1422 6.15552 12.6182C2.75152 10.9978 1.2311 8.87483 1.2311 5.77209V2.61283C1.43424 2.62539 1.63737 2.63167 1.84666 2.63167C3.39785 2.63167 4.87517 2.23598 6.15552 1.48228C7.23274 2.11664 8.45153 2.49349 9.73188 2.60027L10.9507 1.35666C10.7906 1.36922 10.6306 1.3755 10.4644 1.3755C9.01784 1.3755 7.639 0.973531 6.48792 0.219829L6.15552 0L5.82312 0.219829C4.67204 0.973531 3.29936 1.3755 1.84666 1.3755C1.45886 1.3755 1.07722 1.3441 0.707885 1.28757L0 1.17452V5.77209C0 10.6209 3.36707 12.725 5.90314 13.8807L6.15552 13.9937L6.4079 13.8807C8.94397 12.7187 12.311 10.6146 12.311 5.77209V5.29475L11.0368 6.59489Z"
              fill={
                activeLabels?.includes("Reliability")
                  ? "#0090FF"
                  : getIconMutedColor(themeDark)
              }
            />
            <path
              d="M6.19861 9.75412L2.69612 6.88377L3.45941 5.90396L6.11244 8.07085L12.4896 1.55762L13.3636 2.4495L6.19861 9.75412Z"
              fill={
                activeLabels?.includes("Reliability")
                  ? "#0090FF"
                  : getIconMutedColor(themeDark)
              }
            />
          </g>
          <defs>
            <clipPath id="clip0_4880_6112">
              <rect width="13.3636" height="14" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "Misconfiguration",
      icon: (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <g clipPath="url(#clip0_6994_6498)">
            <path
              d="M14.0004 6.45156C14.0249 5.59845 13.7238 4.768 13.1583 4.1288C12.5927 3.4896 11.8052 3.08956 10.9554 3.0099C10.9304 3.00535 10.907 2.99434 10.8876 2.97797C10.8681 2.9616 10.8533 2.94043 10.8446 2.91656C10.3842 2.14471 9.70233 1.52916 8.88755 1.14989C8.07277 0.770635 7.16275 0.645199 6.27575 0.789888C5.38875 0.934576 4.56577 1.3427 3.91375 1.96122C3.26172 2.57975 2.8108 3.38008 2.61958 4.25823C2.61241 4.28778 2.59619 4.31434 2.57318 4.33422C2.55017 4.35409 2.52152 4.36627 2.49125 4.36906C2.0557 4.40376 1.6349 4.54271 1.26433 4.77418C0.893761 5.00566 0.584308 5.32288 0.362081 5.69906C0.10958 6.13199 -0.0157688 6.62732 0.000413869 7.12823C-0.00633618 7.46274 0.0542169 7.79519 0.178476 8.10584C0.302734 8.41649 0.488164 8.69899 0.723747 8.93656C1.05208 9.25073 1.45279 9.47914 1.89041 9.60156C1.97255 9.62312 2.05841 9.62648 2.14198 9.61141C2.22556 9.59634 2.30483 9.56321 2.37427 9.51432C2.44371 9.46544 2.50164 9.40198 2.54401 9.32838C2.58638 9.25479 2.61217 9.17283 2.61958 9.08823C2.62442 8.9573 2.58505 8.82856 2.5078 8.72274C2.43055 8.61692 2.31992 8.54018 2.19375 8.5049C1.94003 8.44023 1.70708 8.31171 1.51708 8.13156C1.38666 7.98844 1.28803 7.81931 1.22771 7.63531C1.16738 7.45132 1.14672 7.25663 1.16708 7.06406C1.16631 6.86544 1.20486 6.66863 1.28051 6.48498C1.35617 6.30133 1.46743 6.13447 1.60787 5.99402C1.74832 5.85358 1.91518 5.74232 2.09883 5.66666C2.28248 5.59101 2.47929 5.55246 2.67791 5.55323C2.78193 5.55366 2.8856 5.56539 2.98708 5.58823C3.07282 5.60575 3.1614 5.60376 3.24626 5.5824C3.33112 5.56104 3.41008 5.52086 3.47731 5.46484C3.54453 5.40882 3.59829 5.33839 3.63461 5.25877C3.67092 5.17915 3.68885 5.09239 3.68708 5.0049C3.73958 1.6624 8.52875 0.70573 9.99875 3.83823C10.0477 3.94116 10.1257 4.0275 10.2231 4.08659C10.3206 4.14568 10.4332 4.17493 10.5471 4.17073C10.9314 4.15471 11.3132 4.24005 11.6542 4.41821C11.9951 4.59636 12.2832 4.86106 12.4896 5.18573C12.7085 5.51871 12.8279 5.90726 12.8337 6.30573C12.8571 6.63745 12.7999 6.96991 12.6668 7.27467C12.5337 7.57942 12.3288 7.84742 12.0696 8.05573C11.9903 8.11709 11.9293 8.19902 11.8933 8.29261C11.8573 8.3862 11.8477 8.48787 11.8654 8.58656V8.58656C11.8832 8.68349 11.9252 8.77434 11.9875 8.85064C12.0499 8.92694 12.1305 8.98621 12.222 9.0229C12.3134 9.0596 12.4127 9.07253 12.5105 9.06049C12.6083 9.04846 12.7014 9.01184 12.7812 8.95406C13.1623 8.65792 13.4703 8.27833 13.6817 7.8445C13.893 7.41067 14.0021 6.93414 14.0004 6.45156V6.45156Z"
              fill={activeLabels?.includes('Misconfiguration') ? "#E31174" : getIconMutedColor(themeDark)}            />
            <path
              d="M11.0843 9.44987C11.0843 8.69995 10.8619 7.96687 10.4453 7.34333C10.0287 6.7198 9.43649 6.23381 8.74365 5.94683C8.05082 5.65985 7.28844 5.58476 6.55293 5.73106C5.81742 5.87736 5.14181 6.23848 4.61153 6.76876C4.08126 7.29903 3.72014 7.97464 3.57383 8.71015C3.42753 9.44567 3.50262 10.208 3.7896 10.9009C4.07658 11.5937 4.56257 12.1859 5.18611 12.6025C5.80964 13.0192 6.54272 13.2415 7.29265 13.2415C8.29778 13.24 9.26131 12.84 9.97205 12.1293C10.6828 11.4185 11.0828 10.455 11.0843 9.44987V9.44987ZM8.83848 7.8982C8.92041 7.98024 8.96643 8.09143 8.96643 8.20737C8.96643 8.32331 8.92041 8.43451 8.83848 8.51654L8.01598 9.3332C8.00203 9.3463 7.99091 9.36211 7.98331 9.37967C7.97571 9.39723 7.97179 9.41616 7.97179 9.43529C7.97179 9.45442 7.97571 9.47335 7.98331 9.49091C7.99091 9.50847 8.00203 9.52428 8.01598 9.53737L8.83848 10.3657C8.92041 10.4477 8.96643 10.5589 8.96643 10.6749C8.96643 10.7908 8.92041 10.902 8.83848 10.984C8.75645 11.066 8.64525 11.112 8.52931 11.112C8.41337 11.112 8.30218 11.066 8.22015 10.984L7.39765 10.1557C7.36877 10.1299 7.33139 10.1156 7.29265 10.1156C7.2539 10.1156 7.21652 10.1299 7.18764 10.1557L6.36515 10.984C6.28311 11.066 6.17192 11.112 6.05598 11.112C5.94004 11.112 5.82884 11.066 5.74681 10.984C5.66488 10.902 5.61886 10.7908 5.61886 10.6749C5.61886 10.5589 5.66488 10.4477 5.74681 10.3657L6.56931 9.53737C6.58326 9.52428 6.59438 9.50847 6.60198 9.49091C6.60958 9.47335 6.6135 9.45442 6.6135 9.43529C6.6135 9.41616 6.60958 9.39723 6.60198 9.37967C6.59438 9.36211 6.58326 9.3463 6.56931 9.3332L5.74681 8.51654C5.66953 8.4336 5.62746 8.32391 5.62946 8.21057C5.63146 8.09722 5.67738 7.98908 5.75753 7.90893C5.83769 7.82877 5.94583 7.78285 6.05917 7.78085C6.17252 7.77885 6.28221 7.82092 6.36515 7.8982L7.18764 8.74987C7.20125 8.76399 7.21756 8.77521 7.2356 8.78288C7.25364 8.79055 7.27304 8.7945 7.29265 8.7945C7.31225 8.7945 7.33165 8.79055 7.34969 8.78288C7.36773 8.77521 7.38404 8.76399 7.39765 8.74987L8.22015 7.92154C8.25921 7.8794 8.30619 7.84537 8.35841 7.8214C8.41063 7.79742 8.46706 7.78396 8.52448 7.78179C8.5819 7.77963 8.63918 7.78879 8.69306 7.80877C8.74693 7.82874 8.79635 7.85913 8.83848 7.8982V7.8982Z"
              fill={activeLabels?.includes('Misconfiguration') ? "#E31174" : getIconMutedColor(themeDark)}            />
          </g>
          <defs>
            <clipPath id="clip0_6994_6498">
              <rect width="14" height="14" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: "Optimization",
      icon: (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            d="M1 8.93506C0.867392 8.93506 0.740215 8.98774 0.646447 9.0815C0.552678 9.17527 0.5 9.30245 0.5 9.43506V10.1851C0.5 10.2182 0.51317 10.25 0.536612 10.2734C0.560054 10.2969 0.591848 10.3101 0.625 10.3101H2.375C2.40815 10.3101 2.43995 10.2969 2.46339 10.2734C2.48683 10.25 2.5 10.2182 2.5 10.1851V9.43506C2.5 9.30245 2.44732 9.17527 2.35355 9.0815C2.25979 8.98774 2.13261 8.93506 2 8.93506H1Z"
            fill={
              activeLabels?.includes("Optimization")
                ? "#7DDBDE"
                : getIconMutedColor(themeDark)
            }
          />
          <path
            d="M4 7.43506C3.86739 7.43506 3.74021 7.48774 3.64645 7.58151C3.55268 7.67527 3.5 7.80245 3.5 7.93506V10.1851C3.5 10.2182 3.51317 10.25 3.53661 10.2734C3.56005 10.2969 3.59185 10.3101 3.625 10.3101H5.375C5.40815 10.3101 5.43995 10.2969 5.46339 10.2734C5.48683 10.25 5.5 10.2182 5.5 10.1851V7.93506C5.5 7.80245 5.44732 7.67527 5.35355 7.58151C5.25979 7.48774 5.13261 7.43506 5 7.43506H4Z"
            fill={
              activeLabels?.includes("Optimization")
                ? "#7DDBDE"
                : getIconMutedColor(themeDark)
            }
          />
          <path
            d="M7 5.68506C6.86739 5.68506 6.74021 5.73774 6.64645 5.83151C6.55268 5.92527 6.5 6.05245 6.5 6.18506V10.1851C6.5 10.2182 6.51317 10.25 6.53661 10.2734C6.56005 10.2969 6.59185 10.3101 6.625 10.3101H8.375C8.40815 10.3101 8.43995 10.2969 8.46339 10.2734C8.48683 10.25 8.5 10.2182 8.5 10.1851V6.18506C8.5 6.05245 8.44732 5.92527 8.35355 5.83151C8.25979 5.73774 8.13261 5.68506 8 5.68506H7Z"
            fill={
              activeLabels?.includes("Optimization")
                ? "#7DDBDE"
                : getIconMutedColor(themeDark)
            }
          />
          <path
            d="M9.625 10.3101H11.375C11.4082 10.3101 11.4399 10.2969 11.4634 10.2734C11.4868 10.25 11.5 10.2182 11.5 10.1851V4.18506C11.5 4.05245 11.4473 3.92527 11.3536 3.83151C11.2598 3.73774 11.1326 3.68506 11 3.68506H10C9.86739 3.68506 9.74021 3.73774 9.64645 3.83151C9.55268 3.92527 9.5 4.05245 9.5 4.18506V10.1851C9.5 10.2182 9.51317 10.25 9.53661 10.2734C9.56005 10.2969 9.59185 10.3101 9.625 10.3101Z"
            fill={
              activeLabels?.includes("Optimization")
                ? "#7DDBDE"
                : getIconMutedColor(themeDark)
            }
          />
          <path
            d="M9.0353 2.10509L9.1903 2.33509C9.22426 2.38612 9.27036 2.42791 9.32447 2.45671C9.37858 2.48551 9.439 2.50042 9.5003 2.50009C9.56395 2.49779 9.62594 2.47908 9.68025 2.4458C9.73455 2.41251 9.77935 2.36577 9.8103 2.31009L10.8103 0.560093C10.847 0.500773 10.8665 0.432375 10.8665 0.362593C10.8665 0.292811 10.847 0.224413 10.8103 0.165093C10.7733 0.106273 10.7202 0.0593987 10.6572 0.0301218C10.5942 0.000844864 10.5241 -0.009584 10.4553 9.2854e-05L8.4553 0.250093C8.39193 0.258107 8.33166 0.282172 8.2802 0.320008C8.22875 0.357843 8.18781 0.408195 8.16126 0.466289C8.13472 0.524383 8.12345 0.588293 8.12854 0.651961C8.13362 0.715629 8.15488 0.776944 8.1903 0.830093L8.3403 1.06009C8.34953 1.07343 8.35596 1.08851 8.3592 1.1044C8.36244 1.1203 8.36243 1.13669 8.35916 1.15258C8.35588 1.16847 8.34942 1.18353 8.34017 1.19685C8.33091 1.21018 8.31905 1.22148 8.3053 1.23009L1.2253 5.96009C1.17033 5.99642 1.12309 6.04325 1.08628 6.09789C1.04948 6.15253 1.02383 6.21391 1.01082 6.27849C0.997812 6.34308 0.997695 6.40959 1.01048 6.47422C1.02326 6.53885 1.04868 6.60032 1.0853 6.65509C1.13116 6.72295 1.19299 6.7785 1.26535 6.81686C1.33772 6.85522 1.41839 6.87522 1.5003 6.87509C1.5986 6.87622 1.69477 6.84649 1.7753 6.79009L8.8603 2.07009C8.87403 2.06074 8.8895 2.05423 8.90578 2.05092C8.92207 2.04762 8.93885 2.0476 8.95514 2.05086C8.97144 2.05411 8.98692 2.06059 9.00068 2.0699C9.01444 2.07922 9.02621 2.09118 9.0353 2.10509Z"
            fill={
              activeLabels?.includes("Optimization")
                ? "#7DDBDE"
                : getIconMutedColor(themeDark)
            }
          />
          <path
            d="M0.499857 12H11.4999C11.6187 11.9997 11.7335 11.9572 11.8238 11.8799C11.9141 11.8027 11.9739 11.6958 11.9925 11.5785C12.0112 11.4612 11.9874 11.341 11.9256 11.2396C11.8637 11.1382 11.7677 11.0621 11.6549 11.025C11.6047 11.009 11.5525 11.0006 11.4999 11H0.499857C0.447235 11.0006 0.394996 11.009 0.344857 11.025C0.231987 11.0621 0.136017 11.1382 0.07414 11.2396C0.0122635 11.341 -0.0114748 11.4612 0.00717859 11.5785C0.025832 11.6958 0.0856579 11.8027 0.175937 11.8799C0.266216 11.9572 0.381048 11.9997 0.499857 12Z"
            fill={
              activeLabels?.includes("Optimization")
                ? "#7DDBDE"
                : getIconMutedColor(themeDark)
            }
          />
        </svg>
      ),
    },
  ];

  useEffect(() => {
    checkInsightTypeExiests()
  },[insights, allInsights])

  const checkInsightTypeExiests = () => {
    if(_.isEmpty(insights) && _.isEmpty(allInsights)) {
      return;
    }
    // enrich insights with their full data;
    const enrichInsights = insights ? allInsights?.filter((item) => insights.includes(item?.id)): [];

    // get label types only
    const labelsOnly = _.map(enrichInsights || [], (item) => item?.labels);

    // distinct types
    const assetUniqLables = _.uniq(_.flatten(labelsOnly));
    return setActiveLabels(assetUniqLables)
  }

  const renderLabels = () => {

    return _.map(labels || [], (item) => {
      return (
        <Tooltip
          key={item?.name}
          placement="top"
          title={activeLabels?.includes(item?.name) ? `${item?.name} insight` : item?.name}
          overlayInnerStyle={{
            maxWidth: "150px",
            padding: "10px",
            fontSize: "13px",
          }}
        >
          <button
            onClick={
              activeLabels?.includes(item?.name)
                ? onClick
                : () => {
                    return false;
                  }
            }
            className="InsightsLabelIndicator center"
            style={{
              cursor: activeLabels?.includes(item?.name) ? "pointer" : "default",
            }}
          >
            {item?.icon}
          </button>
        </Tooltip>
      );
    });
  };
  return (
    <div className="row" style={{ gap: "10px" }}>
      {renderLabels()}
    </div>
  );
};

export default InsightsLabelIndicator;
